import $ from '../$';
import param from '../functions/param';
$.param = param;
